"use client";
import { useIsMobile } from "@/hooks/useIsMobile";

import { Modal } from "@/utils/bootstrap";
import Attributes from "@/app/components/pages-components/product-details-page/details-belpers/product-attributes/Attributes";
import HBtnExpandingAddToCard from "../../product/product-box/product-box-helpers/btn-expanding-add-to-card/btn-esxpanding-types/HBtnExpandingAddToCard";
import { IProductMinimizedData } from "@/app/components/pages-components/product-details-page/details-belpers/product-attributes/helpers/interfaces";
import { IProduct } from "@/api/AppApi/services/home/interfaces/IProduct";

interface ContainerProps {
  children: React.ReactNode;
  isOpen: boolean;
  onClose: () => void;
}

const ProductAttrbuitesPopUp: React.FC<{
  isOpen: boolean;
  onClose: () => void;
  product: IProductMinimizedData;
  setSelectedChildIndex: (idx: number | null) => void;
  attrsInitValues: number[];
  quantity: number;
  increaseQty: (e: React.MouseEvent, value?: number) => void;
  decreaseQty: (value?: number) => void;
  viewDetails: boolean;
  outOfStock: boolean;
  maxQuantity: number;
  minQuantity: number;
  enable_sells: boolean;
  viewDetailsClick: () => void;
  HBFullWidth: boolean;
  isConfigurableProduct: boolean;
  addToCartTxt?: string;
  handleChangeQty: (value: number) => void;
  preview_type: string;
  addedToCart: boolean;
  isAddingToCart: boolean;
  choose_variant: boolean;
  shouldReminder?: boolean;
  productProps?: IProduct;
}> = ({
  isOpen,
  onClose,
  product,
  setSelectedChildIndex,
  attrsInitValues,
  HBFullWidth,
  preview_type,
  quantity,
  increaseQty,
  decreaseQty,
  viewDetails,
  outOfStock,
  maxQuantity,
  minQuantity,
  enable_sells,
  viewDetailsClick,
  isConfigurableProduct,
  addToCartTxt,
  handleChangeQty,
  addedToCart,
  isAddingToCart,
  choose_variant,
  shouldReminder,
  productProps,
}) => {
  const mobile = useIsMobile();
  const mClass = mobile ? "-mobile" : "";
  const ispopup = true;
  const isPopupMobile = mobile && ispopup;

  return (
    <Container isOpen={isOpen} onClose={onClose}>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: isPopupMobile ? 0 : 24,
          padding: isPopupMobile ? 40 : 24,
        }}
      >
        <div
          className={`product-details-container${ispopup ? "-pop-up" : mClass}`}
          style={
            isPopupMobile
              ? {
                  maxWidth: "100%",
                  justifyContent: "space-between",
                }
              : {}
          }
        >
          {product?.attributes_builder?.length > 0 && (
            <div id="attributes-selector">
              <Attributes
                product={product}
                setSelectedChildIndex={(idx) => setSelectedChildIndex(idx)}
                initialValues={attrsInitValues}
                autoSelectFirstChild={false}
                noStepper
              />
            </div>
          )}
        </div>
        <HBtnExpandingAddToCard
          HBFullWidth={HBFullWidth}
          preview_type={preview_type}
          quantity={quantity}
          increaseQty={increaseQty}
          decreaseQty={decreaseQty}
          viewDetails={viewDetails}
          outOfStock={outOfStock}
          maxQuantity={maxQuantity}
          minQuantity={minQuantity}
          enable_sells={enable_sells}
          viewDetailsClick={viewDetailsClick}
          isConfigurableProduct={!!isConfigurableProduct}
          addToCartTxt={addToCartTxt}
          handleChangeQty={handleChangeQty}
          addedToCart={addedToCart}
          isLoading={isAddingToCart}
          choose_variant={choose_variant}
          shouldReminder={shouldReminder}
          productProps={productProps}
        />
      </div>
    </Container>
  );
};
export default ProductAttrbuitesPopUp;

const Container: React.FC<ContainerProps> = ({ children, isOpen, onClose }) => {
  const mCLass = "product-popup-container";
  const dialogClassName = "messagebox-dialog";

  const contentClassName = "pop-up-modal-contents";
  return (
    <Modal
      centered
      show={isOpen}
      onHide={onClose}
      dialogClassName={dialogClassName}
      contentClassName={contentClassName}
    >
      <div className={mCLass} style={{ width: 350 }}>
        {children}
      </div>
    </Modal>
  );
};
